import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';

import PopupStore from '../../../stores/PopupStore';
import ConfigStore from '../../../stores/ConfigStore';
import UserStore from '../../../stores/UserStore';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';

import JournalEntries from './JournalEntries.react';
import JournalNote from './JournalNote.react';
import JournalDetails from './JournalDetails.react';
import GuestStore from '../../../stores/GuestStore';
import AjaxPromises from '../../../utils/AjaxPromises';

class Journal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selected : false,
            notes    : this.props.data
        };

        this.refreshNotes = this.refreshNotes.bind(this);
    }
    
    componentWillUnmount() {
        GuestStore.showCollector(true);
    }

    refreshNotes() {
        var self = this;

        var formData        = UserStore.getApiData();
        formData.Guest_id   = this.props.guest.Guest_id;

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(EndPoints.VIEW_PATIENT_NOTES,
                formData).then(res => {

                    NotificationActions.addNotification({
                        type : res.Result ? 'success' : 'error',
                        body : res.Result ? 'Journal Notes updated' : res.Message,
                    });

                    if (res.Result) {
                        var selected = false;
                        for (var i=0; i<res.Data.length; i++)
                            if (res.Data[i].NoteId === self.state.selected.NoteId)
                                selected = res.Data[i];

                        self.setState({
                            notes : res.Data,
                            selected : selected,
                        });
                    }
                }
            );
        });
    }

    render() {
        var guest    = this.props.guest;
        var notes    = this.state.notes;
        var selected = this.state.selected;

        return (
            <div className='popup__content journal'>


                    <div className='popup-header'>
                        Journal

                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <JournalNote
                        selected={selected}
                        guest={guest}
                        onRefresh={this.refreshNotes} />

                    <JournalEntries
                        notes={notes}
                        selected={selected}
                        onSelect={(note) => { this.setState({ selected : note }); }}
                        onRefresh={this.refreshNotes} />

            </div>
        );
    }
}

export default Journal;


/*
                <JournalDetails
                    selected={selected} />

*/


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/journal/Journal.react.jsx